"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberRange = void 0;
const flow_connect_1 = require("flow-connect");
const core_1 = require("flow-connect/core");
const ui_1 = require("flow-connect/ui");
class NumberRange extends core_1.Node {
    constructor() {
        super();
        this.startValue = 0;
        this.value = 0;
    }
    setupIO() {
        this.addTerminals([
            { type: flow_connect_1.TerminalType.IN, name: "trigger", dataType: "event" },
            { type: flow_connect_1.TerminalType.IN, name: "reset", dataType: "event" },
            { type: flow_connect_1.TerminalType.OUT, name: "value", dataType: "number" },
        ]);
    }
    created(options) {
        const { width = 200, name = "Number Range", state = {}, style = {} } = options;
        this.width = width;
        this.name = name;
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.state = Object.assign(Object.assign({}, NumberRange.DefaultState), state);
        this.setupUI();
        this.setupListeners();
    }
    process() {
        this.value = (0, flow_connect_1.clamp)(this.value + this.state.step, this.state.min, this.state.max);
        if (this.state.loop)
            this.value = this.startValue;
        else
            return;
        this.setOutputs(0, this.value);
    }
    setupUI() {
        this.minInput = this.createUI("core/input", {
            propName: "min",
            input: true,
            output: true,
            height: 20,
            style: { type: ui_1.InputType.Number, grow: 0.3, step: "any" },
        });
        this.maxInput = this.createUI("core/input", {
            propName: "max",
            input: true,
            output: true,
            height: 20,
            style: { type: ui_1.InputType.Number, grow: 0.3, step: "any" },
        });
        this.stepInput = this.createUI("core/input", {
            propName: "step",
            input: true,
            output: true,
            height: 20,
            style: { type: ui_1.InputType.Number, grow: 0.3, step: "any" },
        });
        this.loopToggle = this.createUI("core/toggle", {
            propName: "loop",
            input: true,
            output: true,
            height: 10,
            style: { grow: 0.2 },
        });
        this.ui.append([
            this.createUI("core/x-layout", {
                childs: [
                    this.createUI("core/label", { text: "Min", style: { grow: 0.2 } }),
                    this.minInput,
                    this.createUI("core/label", { text: "Max", style: { grow: 0.2 } }),
                    this.maxInput,
                ],
                style: { spacing: 5 },
            }),
            this.createUI("core/x-layout", {
                childs: [this.createUI("core/label", { text: "Step", style: { grow: 0.2 } }), this.stepInput],
                style: { spacing: 5 },
            }),
            this.createUI("core/x-layout", {
                childs: [this.createUI("core/label", { text: "Loop ?", style: { grow: 0.2 } }), this.loopToggle],
                style: { spacing: 10 },
            }),
        ]);
    }
    setupListeners() {
        this.watch("min", () => this.process());
        this.watch("max", () => this.process());
        this.watch("step", () => this.process());
        this.watch("loop", () => this.process());
        this.inputs[0].on("event", () => this.process());
        this.inputs[1].on("event", () => (this.value = this.state.min));
    }
}
exports.NumberRange = NumberRange;
NumberRange.DefaultState = { min: 0, max: 100, step: 1, loop: false };
